import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../../..';
import {useAuth} from '../../../../../config/AuthProvider/authProvider';
import DrawerBody from '../../../../requestSteps/drawerBody/drawerBody';
import Cheques from '../../../../cheques/cheques';
import {useAppBar} from '../../../../../components/appBar/appBarContext';
import {
    changeRouteType,
    getNextInnerState,
} from '../../../../../redux/handleBackBtn/handleBackBtnSlice';
import {useMutation} from 'react-query';
import {
    ICheqeuResponse,
    IGetCheqeuRequest,
} from '../../../../../models/cheque.model';
import {GetCheques} from '../../../../../services/cheque.service';
import ChequeInfo from '../../../../cheques/chequeInfo';
import {setHeaderTitle} from '../../../../../redux/headerTitle/headerTitleSlice';
import {TInnerStateInstallmentCheque} from './TInnerStateInstallmentCheque';
import React from 'react';

export default function InstallmentChequeContainer() {
    const [state, setState] =
        useState<TInnerStateInstallmentCheque>('installmentCheque');
    const stateFromRedux = useSelector(
        (state: RootState) => state.prevAndNextState.nextInnerState
    ) as TInnerStateInstallmentCheque;
    const {referenceKey, setRefKey} = useAuth();
    const [cheques, setCheques] = useState<ICheqeuResponse[]>();
    const [chequeIndex, setChequeIndex] = useState<number>(1);
    const [selectedCheque, setSelectedCheque] = useState<ICheqeuResponse>();

    // const { setHeader } = useAppBar();
    const dispatch = useDispatch();

    const {mutateAsync: getChequeMutation, isLoading} = useMutation(
        GetCheques,
        {
            onSuccess: (data: ICheqeuResponse[]) => {
                if (data) {
                    setCheques(data);
                }
            },
        }
    );

    const handleClick = (chequeId: number, index: number) => {
        const temp = cheques?.filter((item) => item.chequeId == chequeId);
        if (temp) {
            setSelectedCheque(temp[0]);
        }
        setChequeIndex(index);
        //  setState("chequeInfo")
        dispatch(getNextInnerState({nextInnerState: 'chequeInfo'}));
        dispatch(changeRouteType({routeType: 'child'}));
    };

    useEffect(() => {
        const request = {} as IGetCheqeuRequest;
        request.referenceKey = referenceKey!;
        request.chequeType = 'Installment';
        request.chequeId = null;
        request.loadChequeImage = true;
        getChequeMutation(request);
    }, []);

    useEffect(() => {
        if (stateFromRedux === 'installmentCheque') {
            setState('installmentCheque');
            dispatch(changeRouteType({routeType: 'loans'}));
            dispatch(
                setHeaderTitle({
                    // color: "linear-gradient(120deg,#FFFFFF, #E8F5E9)",
                    color: 'var(--header-color)',
                    header: 'جزییات تسهیلات',
                    parentRoute: 'loans',
                })
            );
        } else {
            setState(stateFromRedux);
        }
    }, [stateFromRedux]);

    const innerStep = {
        installmentCheque: (
            <Cheques cheques={cheques} handleClick={handleClick} />
        ),
        chequeInfo: <ChequeInfo cheque={selectedCheque!} index={chequeIndex} />,
    };

    return <DrawerBody isAssigned>{innerStep[state!]}</DrawerBody>;
}
